// TrustRegistration.jsx
import React from "react";

export default function TrustRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Trust Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Trust Registration Support in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists in Trust Registration with legally
            compliant documentation, helping founders create a clear framework
            for charitable, religious, or private objectives.
          </p>
          <p className="text-gray-700">
            From drafting and finalizing the trust deed to organizing trustee
            KYC and address documents, the registration process is handled in a
            structured manner so the trust can be set up with legal clarity and
            recognition.
          </p>
        </div>

        {/* Right: Image (square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184644/pexels-photo-3184644.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Professionals drafting a trust deed and planning registration"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Trust Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps founders and trustees collate and
              prepare the documents required for smooth trust registration with
              the appropriate authority.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Draft trust deed setting out the name, objects, trustees,
                  beneficiaries, and administration provisions.
                </li>
                <li>PAN card of the trust (if available) or of the settlor / key trustees.</li>
                <li>
                  Identity proof of trustees and settlor (Aadhaar, passport,
                  voter ID, or driving licence).
                </li>
                <li>
                  Residential address proof of trustees and settlor (utility
                  bill, bank statement, or similar).
                </li>
                <li>
                  Registered office address proof of the trust (rent / lease
                  agreement or ownership proof, recent utility bill, and NOC
                  from owner where applicable).
                </li>
                <li>
                  Passport-size photographs and basic contact details of
                  trustees and settlor.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers dedicated support for trust formation, combining
              legal drafting capability with a clear, process-driven approach to
              registration and basic compliance.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Legal Structuring Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on trust objectives, governance provisions, and
                  trustee roles so that the deed reflects the founders'
                  intentions while staying aligned with legal norms.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Transparent Compliance Process
                </h3>
                <p className="text-gray-700 text-sm">
                  Clear explanation of steps, timelines, and documentation,
                  helping founders understand how the registration will proceed
                  from draft to final registration.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Responsive, professional assistance throughout drafting,
                  submission, and follow-up stages, offering dependable support
                  for setting up the trust.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
